import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

/*
Der Webservice ESR_session gibt eine für diese Anfrage eindeutige ID zurück, 
welche für die weiteren Webservices zu der jeweiligen Anfrage mitgegeben werden muss.
*/

interface Option{
    "sort_index": number,
    "code": string, 
    "material": string, 
    "thickness": number, 
    "u_value": number,
    "label": string,
}

interface Options{
    "current_state": Array<Option>;
    "planned_state": Array<Option>;
}

interface MeasureInterface{
    "description": string;
    "isfp": boolean;
    "options": Options;
}

interface Measures{
    "facade_insulation": MeasureInterface;
    "floor_insulation": MeasureInterface;
    "window": MeasureInterface;
    "heating_system": MeasureInterface;
    "ventilation_system": MeasureInterface;
    "solar_thermal": MeasureInterface;
    "photovoltaics": MeasureInterface;
}

export type BuildingTypeKeys = "sfh" | "thm" | "the" | "mfh" | "mfm" | "mfe";

export interface ESRGetTradeMeasuresResponse{
    "building_types": { BuildingTypeKeys : string };
    "measures": Measures
}

const OptionSchema: SchemaObject = {
    "code": 'string', 
    "material": 'string', 
    "thickness": 'number', 
    "u_value": 'number'
}

const OptionsSchema : SchemaObject = {
    "current_state": [OptionSchema],
    "planned_state": [OptionSchema],
}

const MeasureSchema : SchemaObject = {
    "description": 'string',
    "isfp": 'boolean',
    "options": OptionsSchema,
}

const ESRGetTradeMeasuresResponseSchema : SchemaObject = {
    "building_types": {},
    "measures": MeasureSchema,

}

export class ESRGetTradeMeasures extends Request<ESRGetTradeMeasuresResponse>{
    override method : TRequestMethod = "GET";
    override responseSchema : Schema = ESRGetTradeMeasuresResponseSchema;

    constructor ( public sessionToken: string){
        super();
    }

    override route() : string{
        return `${BASEURL}/get_trade_measures?sessionToken=${this.sessionToken}`;
    }
}